"use strict";
var Observable_1 = require('../../Observable');
var skipUntil_1 = require('../../operator/skipUntil');
Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
//# sourceMappingURL=skipUntil.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/rxjs/add/operator/skipUntil.js
// module id = ../../../../rxjs/add/operator/skipUntil.js
// module chunks = 7